var map = {
	"./agt.svg": "5be4",
	"./amatic.svg": "b976",
	"./arc.svg": "4836",
	"./betdata.svg": "61cb",
	"./betgames.svg": "f464",
	"./betradar.svg": "fdb3",
	"./evolution.svg": "6a7e",
	"./globalbet.svg": "204b",
	"./habanero.svg": "02c6",
	"./kiron.svg": "ab63",
	"./pragmatic.svg": "880c",
	"./sis.svg": "16c7",
	"./tvmanager.svg": "da05"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "78ea";